<div class="pointer-events-none invisible">
  <ng-content></ng-content>
</div>
